import React from "react";

export default function ContactMe () {
    return(
        <section id="Contact" className="contact--section">
            <div>
                <p className="sub--title">Get In Touch</p>
                <h2>Contact Me</h2>
            </div>
            <div className="contact--section--card">
                <div className="contact--card">
                    <img src="./img/email.png" alt="Email Icon" className="email-logo"></img>
                    <p><a href="mailto:desaihetvi98@gmail.com">hetvicdesai@gmail.com</a></p>
                </div>
                <div className="contact--card">
                    <img src="./img/call.png" alt="Call Icon" className="call-logo"></img>
                    <p><a href="tel:6822181284">682-218-1284</a></p>
                </div>
            </div>

        </section>
    );
}